(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["legend-suite-core"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.legendSuiteBooted) return;
  window.legendSuiteBooted = true;
  const init = (scope = document) => {
    scope.querySelectorAll('[data-lk-suite]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const msg = (key) => root.querySelector(`[data-lks-copy="${key}"]`)?.textContent || '';
      root.querySelectorAll('[data-faq-search]').forEach((input) => {
        const group = input.closest('[data-faq-group]');
        const filter = () => {
          const query = input.value.trim().toLowerCase();
          let count = 0;
          group.querySelectorAll('details').forEach((item) => {
            const visible = item.textContent.toLowerCase().includes(query);
            item.hidden = !visible;
            if (visible) count++;
          });
          group.querySelector('[data-faq-empty]').hidden = count !== 0;
        };
        input.addEventListener('input', filter);
      });
      root.querySelectorAll('[data-gallery-filter]').forEach((select) => {
        const gallery = select.closest('[data-gallery-group]');
        const cards = [...gallery.querySelectorAll('[data-gallery-card]')];
        const tags = [...new Set(cards.map((card) => card.dataset.category).filter(Boolean))];
        tags.forEach((tag) => { const option = document.createElement('option'); option.value = tag; option.textContent = tag; select.append(option); });
        select.addEventListener('change', () => cards.forEach((card) => { card.hidden = Boolean(select.value && card.dataset.category !== select.value); }));
      });
      root.querySelectorAll('[data-fit-guide]').forEach((guide) => {
        const chartSelect = guide.querySelector('[data-chart-select]');
        const panels = [...guide.querySelectorAll('[data-size-chart]')];
        const compareA = guide.querySelector('[data-size-a]');
        const compareB = guide.querySelector('[data-size-b]');
        const unit = guide.querySelector('[data-chart-unit]');
        if (!chartSelect || !unit || !compareA || !compareB || !panels.length) return;
        guide.querySelectorAll('[data-fit-controls]').forEach((control) => { control.hidden = false; });
        const compare = () => {
          const panel = panels.find((p) => p.dataset.sizeChart === chartSelect.value);
          panels.forEach((item) => item.querySelectorAll('tbody tr').forEach((row) => {
            const selected = item === panel && [compareA.value, compareB.value].filter(Boolean).includes(row.dataset.size);
            row.style.backgroundColor = selected ? '#fff0b5' : '';
            const marker = row.querySelector('[data-comparison-mark]');
            if (marker) marker.hidden = !selected;
          }));
        };
        const switchChart = () => {
          panels.forEach((panel) => { panel.hidden = panel.dataset.sizeChart !== chartSelect.value; });
          const panel = panels.find((p) => !p.hidden);
          [compareA, compareB].forEach((select) => { while (select.options.length > 1) select.remove(1); panel?.querySelectorAll('tbody tr').forEach((row) => { const option = document.createElement('option'); option.value = row.dataset.size; option.textContent = row.dataset.size; select.add(option); }); });
          convert();
          compare();
        };
        const convert = () => panels.forEach((panel) => {
          panel.querySelectorAll('[data-measure-value]').forEach((cell) => {
            const value = Number(cell.dataset.measureValue);
            const source = panel.dataset.unit;
            if (!Number.isFinite(value)) { cell.textContent = cell.dataset.measureValue; return; }
            cell.textContent = source === unit.value ? cell.dataset.measureValue : String(Number((source === 'in' ? value * 2.54 : value / 2.54).toFixed(2)));
          });
          panel.querySelectorAll('[data-unit-label]').forEach((el) => { el.textContent = unit.value === 'cm' ? guide.dataset.cmLabel || 'cm' : guide.dataset.inLabel || 'in'; });
          const conversionNote = panel.querySelector('[data-conversion-note]');
          if (conversionNote) conversionNote.hidden = panel.dataset.unit === unit.value;
        });
        chartSelect.addEventListener('change', switchChart);
        unit.addEventListener('change', convert);
        compareA.addEventListener('change', compare); compareB.addEventListener('change', compare);
        switchChart();
      });
      root.querySelectorAll('[data-carrier-tool]').forEach((tracker) => {
        const carrier = tracker.querySelector('[data-carrier]');
        const number = tracker.querySelector('[data-tracking-number]');
        const link = tracker.querySelector('[data-carrier-link]');
        const bases = {
          ups: 'https://www.ups.com/track?loc=en_US&tracknum=',
          fedex: 'https://www.fedex.com/fedextrack/?trknbr=',
          dhl: 'https://www.dhl.com/us-en/home/tracking.html?tracking-id=',
          usps: 'https://tools.usps.com/go/TrackConfirmAction?tLabels='
        };
        const update = () => { link.href = (bases[carrier.value] || bases.ups) + encodeURIComponent(number.value.trim()); };
        carrier.addEventListener('change', update); number.addEventListener('input', update);
        link.addEventListener('click', (event) => { if (!number.reportValidity()) event.preventDefault(); });
        update();
      });
      root.querySelectorAll('[data-lks-form]').forEach((form) => {
        const draftKey = `legendkits:page:${root.dataset.pageKey}`;
        const fields = [...form.querySelectorAll('[data-lks-field]')];
        const review = form.querySelector('[data-review]');
        const reviewList = form.querySelector('[data-review-list]');
        const reviewButton = form.querySelector('[data-review-button]');
        const submitButton = form.querySelector('[data-submit-button]');
        const ref = form.querySelector('[name="contact[request_reference]"]');
        const roster = form.querySelector('[data-roster]');
        let timer;
        const edit = () => { if (review) review.hidden = true; if (submitButton) submitButton.hidden = true; if (reviewButton) reviewButton.hidden = false; };
        const setRef = () => { if (ref && !ref.value) ref.value = `LK-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2, 6).toUpperCase()}`; };
        const rows = () => roster ? [...roster.querySelectorAll('[data-roster-row]')].map((row) => [...row.querySelectorAll('input')].map((input) => input.value.trim())).filter((row) => row.some(Boolean)) : [];
        const syncRoster = () => { if (roster) { form.querySelector('[name="contact[player_roster]"]').value = rows().map((row) => row.join(' | ')).join('\n'); roster.querySelector('[data-roster-count]').textContent = `${rows().length} / 100`; } };
        const addRow = (values = []) => {
          if (!roster || roster.querySelectorAll('[data-roster-row]').length >= 100) return;
          const fragment = roster.querySelector('template').content.cloneNode(true);
          const row = fragment.querySelector('tr');
          row.querySelectorAll('input').forEach((input, index) => { input.value = values[index] || ''; });
          row.querySelector('button').addEventListener('click', () => { row.remove(); syncRoster(); edit(); save(); });
          roster.querySelector('tbody').append(fragment);
          syncRoster();
        };
        const save = () => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            const values = Object.fromEntries(fields.map((field) => [field.name, field.type === 'checkbox' ? field.checked : field.value]));
            try { sessionStorage.setItem(draftKey, JSON.stringify({time: Date.now(), values, roster: rows(), reference: ref?.value})); } catch {}
          }, 200);
        };
        const clearDraft = () => { clearTimeout(timer); try { sessionStorage.removeItem(draftKey); } catch {} };
        if (root.querySelector('[data-server-success]')) { clearDraft(); return; }
        setRef();
        if (roster) {
          addRow(); addRow(); addRow();
          roster.querySelector('[data-add-player]').addEventListener('click', () => { addRow(); edit(); save(); });
          roster.querySelector('[data-roster-download]').addEventListener('click', () => {
            const csv = '\uFEFFName,Number,Fit,Size,Quantity\r\n';
            const url = URL.createObjectURL(new Blob([csv], {type:'text/csv;charset=utf-8'}));
            const a = document.createElement('a'); a.href = url; a.download = 'legend-kits-roster.csv'; a.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
          });
          roster.querySelector('[data-roster-import]').addEventListener('click', () => {
            const text = roster.querySelector('[data-roster-paste]').value.trim();
            if (!text) return;
            const delimiter = text.includes('\t') ? '\t' : ',';
            const parsed = []; let row = [], cell = '', quoted = false;
            for (let i = 0; i <= text.length; i++) {
              const char = text[i];
              if (char === '"') { if (quoted && text[i + 1] === '"') { cell += '"'; i++; } else quoted = !quoted; }
              else if (!quoted && (char === delimiter || char === '\n' || char === undefined)) { row.push(cell.trim()); cell = ''; if (char !== delimiter) { parsed.push(row); row = []; } }
              else if (char !== '\r') cell += char;
            }
            if (quoted) { roster.querySelector('[data-roster-status]').textContent = msg('roster_error'); return; }
            const incoming = parsed.filter((r, i) => r.some(Boolean) && !(i === 0 && /^(player\s*)?name$/i.test(r[0])));
            if (incoming.length > 100 || incoming.some((r) => r.length !== 5 || r.some((v) => v.length > 100))) { roster.querySelector('[data-roster-status]').textContent = msg('roster_error'); return; }
            roster.querySelector('tbody').replaceChildren(); incoming.forEach(addRow); syncRoster(); edit(); save();
            roster.querySelector('[data-roster-status]').textContent = msg('roster_imported');
          });
          roster.addEventListener('input', syncRoster);
        }
        try {
          const draft = JSON.parse(sessionStorage.getItem(draftKey));
          if (draft && Date.now() - draft.time < 86400000) {
            fields.forEach((field) => { if (Object.hasOwn(draft.values || {}, field.name)) { if (field.type === 'checkbox') field.checked = Boolean(draft.values[field.name]); else field.value = draft.values[field.name]; } });
            if (ref && draft.reference) ref.value = draft.reference;
            if (roster && draft.roster?.length) { roster.querySelector('tbody').replaceChildren(); draft.roster.slice(0,100).forEach(addRow); }
          } else clearDraft();
        } catch { clearDraft(); }
        const params = new URL(location.href).searchParams;
        const productParam = params.get('product');
        if (productParam) {
          try { const url = new URL(productParam, location.origin); if (url.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/i.test(url.pathname)) { const field = form.querySelector('[name="contact[product_link]"]'); if (field && !field.value) field.value = url.origin + url.pathname; } } catch {}
        }
        if (reviewButton) { reviewButton.hidden = false; submitButton.hidden = true; }
        const buildReview = () => {
          syncRoster(); if (!form.reportValidity()) return;
          reviewList.replaceChildren();
          const add = (label, value) => { if (!value) return; const dt = document.createElement('dt'); dt.textContent = label; const dd = document.createElement('dd'); dd.textContent = value; reviewList.append(dt, dd); };
          fields.forEach((field) => add(field.dataset.lksLabel, field.type === 'checkbox' ? (field.checked ? msg('confirmed') : '') : field.value));
          if (roster) add(msg('roster_heading'), rows().map((r) => r.join(' | ')).join('\n'));
          add(msg('reference'), ref.value);
          review.hidden = false; reviewButton.hidden = true; submitButton.hidden = false; review.focus(); save();
        };
        reviewButton?.addEventListener('click', buildReview);
        form.querySelector('[data-edit-request]')?.addEventListener('click', edit);
        form.addEventListener('input', () => { edit(); save(); });
        form.querySelector('[data-clear-draft]')?.addEventListener('click', () => {
          clearDraft(); form.reset(); if (ref) ref.value = ''; setRef(); if (roster) { roster.querySelector('tbody').replaceChildren(); addRow(); addRow(); addRow(); } edit(); form.querySelector('[data-form-status]').textContent = msg('cleared');
        });
        form.addEventListener('submit', (event) => {
          syncRoster(); setRef();
          if (review?.hidden) { event.preventDefault(); buildReview(); return; }
          if (!form.reportValidity()) { event.preventDefault(); return; }
          if (root.dataset.demo === 'true') { event.preventDefault(); form.querySelector('[data-form-status]').textContent = msg('demo'); return; }
          clearTimeout(timer);
          try { sessionStorage.setItem(draftKey, JSON.stringify({time:Date.now(),values:Object.fromEntries(fields.map((f)=>[f.name,f.type==='checkbox'?f.checked:f.value])),roster:rows(),reference:ref.value})); } catch {}
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', () => init());
})();
  } catch(e) { console.error(e); }
})();

})();
